import { usePrefetchQuery, useQuery, UseQueryResult } from '@tanstack/react-query';
import { EntityQueriesObject } from '../queryBase';
import { getThankYouDetails } from './thank-you';
import { UTThankYouDetails } from './thank-you.types';
import { setAuthHeader } from '../index';

const GET_THANK_YOU_DETAILS = 'getThankYouDetails';

type ThankYouDetailsArgs = {
  shareId?: string | null;
  auth: string | null | undefined;
};

const thankYouQueries = {
  details: ({ shareId, auth }: ThankYouDetailsArgs) => ({
    queryKey: [GET_THANK_YOU_DETAILS, shareId, auth],
    queryFn: () => {
      if (!shareId) {
        throw new Error('Missing getThankYouDetails query param: shareId');
      }

      if (auth) {
        setAuthHeader(auth);
      }

      return getThankYouDetails(shareId);
    },
    enabled: !!shareId && !!auth,
  }),
} satisfies EntityQueriesObject;

export function useThankYouDetails(args: ThankYouDetailsArgs): UseQueryResult<UTThankYouDetails> {
  return useQuery(thankYouQueries.details(args));
}

export function useThankYouDetailsPrefetch(args: ThankYouDetailsArgs) {
  usePrefetchQuery(thankYouQueries.details(args));
}
